import store from '@/store';

export default class VoiceTransferEvent {
  constructor(body) {
    window.console.log(
      '[VoiceTransferEvent]',
      JSON.parse(JSON.stringify(body)),
    );
  }
}
